import React from 'react'
import { StyleSheet, View } from 'react-native'

import {
  BG_STYLES,
  Chip,
  CHIP_STATES,
  CHIP_TYPES,
  COLORS,
  COMMON_STYLES,
  CrossIcon,
  FilterIcon,
} from '@dehaat/dds'
import { useTranslation } from 'react-i18next'

interface Props {
  isFilterActive: boolean
  onFilterClick: () => void
  onSortingClick?: () => void
  appliedFilterLabel?: string[]
  onClearFilter?: (filterType: 'date' | 'type') => void
  sortBy?: string
}

const FilterButton = ({
  isFilterActive,
  onFilterClick,
  appliedFilterLabel,
  onClearFilter,
}: Props) => {
  const { t } = useTranslation()
  return (
    <View style={COMMON_STYLES.row}>
      <Chip
        label={'Filters'}
        type={CHIP_TYPES.BADGE}
        state={isFilterActive ? CHIP_STATES.ACTIVE : CHIP_STATES.INACTIVE}
        leftIcon={
          <FilterIcon
            pathProps={{ fill: 'white' }}
            svgProps={{
              height: 14,
              width: 14,
              style: { marginRight: 6 },
            }}
          />
        }
        containerStyle={styles.chipContainer}
        labelStyle={styles.chipLabel}
        activeContainerStyle={styles.chipContainer}
        onClick={onFilterClick}
      />

      {Array.isArray(appliedFilterLabel) &&
        appliedFilterLabel
          .filter(item => item && item.trim() !== '')
          .map((item, index) => {
            const filterType = index === 0 ? 'date' : 'type'

            return (
              <Chip
                key={index}
                label={item}
                type={CHIP_TYPES.BADGE}
                rightIcon={
                  <CrossIcon
                    width={14}
                    height={14}
                    style={{
                      backgroundColor: COLORS.white,
                      borderRadius: 50,
                      padding: 2,
                    }}
                  />
                }
                onClick={() => onClearFilter?.(filterType)} // 👈 clear only that filter
                activeContainerStyle={BG_STYLES.bgBlack}
                containerStyle={styles.chipContainer}
                labelStyle={styles.chipLabel}
              />
            )
          })}
    </View>
  )
}

export default FilterButton

const styles = StyleSheet.create({
  chipContainer: {
    backgroundColor: COLORS.black,
    borderColor: COLORS.black,
  },
  chipLabel: {
    color: COLORS.white,
  },
})
